import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yzm",
  "use": "icon-yzm-usage",
  "viewBox": "0 0 12 13.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 13.7\" id=\"icon-yzm\"><title>资源 4</title><g id=\"icon-yzm_图层_2\" data-name=\"图层 2\"><g id=\"icon-yzm_图层_1-2\" data-name=\"图层 1\"><path d=\"M5.9,13.7H5.8A7,7,0,0,1,.1,9.1,1.1,1.1,0,0,1,0,8.6V3.9A1.5,1.5,0,0,1,1.1,2.4,22.3,22.3,0,0,0,5.5.2a.7.7,0,0,1,1,0,22.3,22.3,0,0,0,4.4,2.2A1.5,1.5,0,0,1,12,3.9V8.6a1.1,1.1,0,0,1-.1.5,7,7,0,0,1-5.7,4.6ZM6,1A21.7,21.7,0,0,1,1.4,3.3a.7.7,0,0,0-.4.6V8.6H1a6.2,6.2,0,0,0,5,4,6.2,6.2,0,0,0,5-4h0V3.9a.7.7,0,0,0-.4-.6A21.7,21.7,0,0,1,6,1Zm.1,0Z\" /><path d=\"M5.6,8.6H5.3L3.6,7.1a.5.5,0,0,1,0-.7.5.5,0,0,1,.7-.1L5.6,7.4,7.7,5.3a.5.5,0,0,1,.7.7L5.9,8.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yzm.svg
// module id = 1hRL
// module chunks = 71